import React from 'react';
import { Button, Typography, Box } from '@material-ui/core';
import 'react-dropzone-uploader/dist/styles.css';
import Dropzone from 'react-dropzone-uploader';
import CardActions from '@material-ui/core/CardActions';
import CircularProgress from '@material-ui/core/CircularProgress';
import FormHelperText from '@material-ui/core/FormHelperText';
import { useStyles } from './css';

export function PdfUploadInput({
    input,
    meta,
    getUploadParams,
    onDelete,
    deleting,
    multiple,
    maxFiles,
    label,
    ...props
}) {
    const classes = useStyles();

    const handleChange = (result, status) => {
        const { meta: resultMeta } = result;
        if (status === 'done') {
            input.onChange({
                s3Key: resultMeta.id,
                height: resultMeta.height,
                width: resultMeta.width,
                size: resultMeta.size,
                fileName: resultMeta.name,
                fileType: resultMeta.type,
                temp: true,
            });
        }
    };

    const handleDelete = s3Key => {
        onDelete(s3Key, () => input.onChange(null));
    };

    if (input.value && input.value.temp !== true) {
        return (
            <Box display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
                <Typography>{input.value.fileName}</Typography>
                <CardActions>
                    <Button
                        size="small"
                        color="secondary"
                        className={classes.imgDeleteButton}
                        onClick={() => handleDelete(input.value.s3Key)}
                    >
                        {deleting ? (
                            <CircularProgress size={24} />
                        ) : (
                            <React.Fragment>Delete</React.Fragment>
                        )}
                    </Button>
                </CardActions>
            </Box>
        );
    } else {
        return (
            <>
                <Dropzone
                    key={'imageUpload_' + props.name}
                    getUploadParams={getUploadParams}
                    onChangeStatus={handleChange}
                    accept="application/pdf"
                    multiple={multiple}
                    maxFiles={maxFiles || 1}
                    maxSizeBytes={20000000}
                    inputContent={
                        <React.Fragment key={'imageUpload_content_' + props.name}>
                            <Typography variant="body1">{label}</Typography>
                            <Typography variant="body2" color="textSecondary">
                                or drop here to upload
                            </Typography>
                        </React.Fragment>
                    }
                    classNames={{
                        dropzone: classes.dropzone,
                        inputLabel: classes.dropzoneParagraph,
                    }}
                />
                {meta.error && <FormHelperText error={true}>{meta.error}</FormHelperText>}
            </>
        );
    }
}
